/** @jsx jsx */
//import { Link, StaticQuery, graphql } from 'gatsby';
import { Box, jsx, Heading } from 'theme-ui';
import styles from './shopName.style';

type PropsType = {
	name?: string;
};

const ShopName: React.FC<PropsType> = ({ name }) => {
	return (
		<Box className="logo" sx={styles.wrapper}>
			<Heading as="h3">{name}</Heading>
		</Box>
	);
};

export default ShopName;
